import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import {CouponInput} from '../../coupon/coupon-input'
import fs from '../../form/form.scss'
import {FormSteps, Step} from '../../form-steps'
import {RegistrationLayout} from '../../registration-layout'
import {Summary} from '../../summary'
import {Summary as SummaryOld} from '../../summary/old'
import {Checkout} from '../index'
import {MembershipSelector} from '../membership-selector'
import {ReservationTimer} from '../reservation-timer'
import {DesktopCheckoutProps} from './interfaces'

export const DesktopCheckout = ({
  reservationExpiration,
  t,
  isMobile,
  openTimeExpiredModal,
  formPageLoaded,
  closeNativeModal,
  scrollToElement,
}: DesktopCheckoutProps) => {
  const {experiments} = useExperiments()
  const updatedCheckoutSummaryEnabled = experiments.enabled(ExperimentNames.UpdatedCheckoutSummary)

  const reservationTimerComponent = (
    <ReservationTimer expires={reservationExpiration} onExpire={openTimeExpiredModal} t={t} isMobile={isMobile} />
  )

  React.useEffect(() => {
    formPageLoaded(true)
    closeNativeModal()
  }, [])

  return (
    <Checkout t={t}>
      {(steps: Step[], currentStep: FormStep) => (
        <div className={classNames(c.formBackgroundColor)}>
          <RegistrationLayout
            Left={<FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />}
            Right={
              <>
                {updatedCheckoutSummaryEnabled ? (
                  reservationTimerComponent
                ) : (
                  <div className={fs.summaryBlock}>{reservationTimerComponent}</div>
                )}
                {!updatedCheckoutSummaryEnabled && (
                  <>
                    <CouponInput currentStep={currentStep} />
                    <MembershipSelector />
                  </>
                )}
                {updatedCheckoutSummaryEnabled ? <Summary currentStep={currentStep} /> : <SummaryOld />}
              </>
            }
          />
        </div>
      )}
    </Checkout>
  )
}
